var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{attrs:{"label":"Text","no-resize":"","rows":"2","value":_vm.value,"hide-details":""}})}
var staticRenderFns = []

export { render, staticRenderFns }